/**
 * @author Evgenij Tyan
 * @version 1.0.1
 * @since 1.0.0
 */

/*
* -------------------------------------------
*           SET TAB INDEX
* -------------------------------------------
*/

export const SET_EXTFILTER_TAB_INDEX = '@@b2b_portal_ui/subscriberMobile/SET_EXTFILTER_TAB_INDEX';

/*
* -------------------------------------------
*           LOAD CURRENT SETTINGS
* -------------------------------------------
*/

export const LOAD_EXTFILTER = '@@b2b_portal_ui/subscriberMobile/LOAD_EXTFILTER';
export const LOAD_EXTFILTER_FAILED = '@@b2b_portal_ui/subscriberMobile/LOAD_EXTFILTER_FAILED';
export const LOAD_EXTFILTER_SUCCESSFUL = '@@b2b_portal_ui/subscriberMobile/LOAD_EXTFILTER_SUCCESSFUL';

/*
* -------------------------------------------
*           SEND NEW SETTINGS
* -------------------------------------------
*/

export const SEND_EXTFILTER = '@@b2b_portal_ui/subscriberMobile/SEND_EXTFILTER';
export const SEND_EXTFILTER_FAILED = '@@b2b_portal_ui/subscriberMobile/SEND_EXTFILTER_FAILED';
export const SEND_EXTFILTER_SUCCESSFUL = '@@b2b_portal_ui/subscriberMobile/SEND_EXTFILTER_SUCCESSFUL';

/*
* -------------------------------------------
*           SAVE NEW SETTINGS
* -------------------------------------------
*/

export const SAVE_EXTFILTER = '@@b2b_portal_ui/subscriberMobile/SAVE_EXTFILTER';
export const SAVE_EXTFILTER_FAILED = '@@b2b_portal_ui/subscriberMobile/SAVE_EXTFILTER_FAILED';
export const SAVE_EXTFILTER_SUCCESSFUL = '@@b2b_portal_ui/subscriberMobile/SAVE_EXTFILTER_SUCCESSFUL';

/*
* -------------------------------------------
*           UPDATE SETTINGS
* -------------------------------------------
*/

export const UPDATE_EXTFILTER = '@@b2b_portal_ui/subscriberMobile/UPDATE_EXTFILTER';
export const UPDATE_EXTFILTER_FAILED = '@@b2b_portal_ui/subscriberMobile/UPDATE_EXTFILTER_FAILED';
export const UPDATE_EXTFILTER_SUCCESSFUL = '@@b2b_portal_ui/subscriberMobile/UPDATE_EXTFILTER_SUCCESSFUL';

/*
* -------------------------------------------
*           DELETE SETTINGS
* -------------------------------------------
*/

export const DELETE_EXTFILTER = '@@b2b_portal_ui/subscriberMobile/DELETE_EXTFILTER';
export const DELETE_EXTFILTER_FAILED = '@@b2b_portal_ui/subscriberMobile/DELETE_EXTFILTER_FAILED';
export const DELETE_EXTFILTER_SUCCESSFUL = '@@b2b_portal_ui/subscriberMobile/DELETE_EXTFILTER_SUCCESSFUL';

/*
* -------------------------------------------
*           CLEAR SETTINGS
* -------------------------------------------
*/

export const CLEAR_FILTER = '@@b2b_portal_ui/subscriberMobile/CLEAR_FILTER';
export const CLEAR_FILTER_FAILED = '@@b2b_portal_ui/subscriberMobile/CLEAR_FILTER_FAILED';
export const CLEAR_FILTER_SUCCESSFUL = '@@b2b_portal_ui/subscriberMobile/CLEAR_FILTER_SUCCESSFUL';
